import { useCallback, useEffect, useRef, useState } from "react";
import { InputWrapper } from "../../pages/auth/auth.style";
import DatePickerComponent from "../datepicker/DatePicker";
import Upload from "../../assets/icons/upload";
import { createReference, getReferences } from "../../services/user";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { convertToBase64 } from "../../utils";
import { AccountSummaryWrapper } from "../../pages/Dashboard/styles/dashboard.style";
import FormLoader from "../FormLoader";
import colors from "../../assets/colors.json";

export default function EmployeeReferenceForm({ status }) {
    const fileInputRef = useRef(null);
    const imageInputRef = useRef(null);
    const signatureInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [imagePassportPreview, setPassportPreview] = useState(null);
    const [signaturePreview, setSignaturePreview] = useState(null);
    const [selectedSignature, setSelectedSignature] = useState(null);
    const [selectedPic, setSelectedPic] = useState([]);
    const [imagePreviewPic, setImagePreviewPic] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const [loadingUploading, setLoadingUploading] = useState(false);
    const { admToken, user } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [edit, setEdit] = useState(false);
    const [data, setData] = useState(null);
    const [form, setForm] = useState({
        id: 0,
        employeeName: "",
        refereeName: "",
        refereeAddressLine1: "",
        refereeAddressLine2: "",
        refereeEmail: "",
        refereePhone1: "",
        refereePhone2: "",
        refereePhone3: "",
        relationshipWithEmployee: "",
        yearsKnown: 0,
        characterComment: "",
        recommendEmployee: "",
        reasonIfNo: "",
        generalComments: "",
        refereePassport: "",
        refereeSignature: "",
        signatureDate: "",
        recommendationLetters: []
    });

    const getRef = useCallback(async () => {
        try {
            setLoading(true)
            const res = await getReferences(admToken, user?.staffId);
            console.log(res);
            if (res.status && res.statusCode === 2) {
                setData(res.data);
            } else {
                setData(null);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }, [admToken, user?.staffId]);

    useEffect(() => {
        getRef();
    }, [user?.staffId]);

    useEffect(() => {
        return () => {
            if (imagePassportPreview) URL.revokeObjectURL(imagePassportPreview);
            if (signaturePreview) URL.revokeObjectURL(signaturePreview);
        };
    }, [imagePassportPreview, signaturePreview]);

    const handlePassportClick = () => {
        fileInputRef.current?.click();
    };

    const handleSignatureUplaod = () => {
        signatureInputRef.current?.click();
    };

    const handleRecommendationClick = () => {
        imageInputRef.current?.click();
    };

    const handleSignChange = async (event) => {
        const file = event.target.files?.[0];
        if (file) {
            if (signaturePreview) URL.revokeObjectURL(signaturePreview);

            const previewUrl = URL.createObjectURL(file);
            setSignaturePreview(previewUrl);

            const base64String = await convertToBase64(file);
            setSelectedSignature(base64String);
        }
    };

    const handleSelectPassport = async (event) => {
        const file = event.target.files?.[0];
        if (file) {
            if (imagePassportPreview) URL.revokeObjectURL(imagePassportPreview);

            const previewUrl = URL.createObjectURL(file);
            setPassportPreview(previewUrl);

            const base64String = await convertToBase64(file);
            setSelectedFile(base64String);

        }
    };

    const handleRecommendationLetter = async (event) => {
        const files = event.target.files;
        if (!files) return;

        imagePreviewPic.forEach((url) => URL.revokeObjectURL(url));

        const fileArray = Array.from(files);
        const previewUrls = fileArray.map((file) => URL.createObjectURL(file));

        const base64Array = await Promise.all(fileArray.map((file) => convertToBase64(file)));

        setSelectedPic(fileArray);
        setImagePreviewPic(previewUrls);
        setBase64Files(base64Array);
    };

    const handleEdit = (item) => {
        setSelectedFile(null);
        setSelectedSignature(null);
        setBase64Files([]);

        setForm({
            ...form,
            id: item.id,
            employeeName: item.employeeName || "",
            refereeName: item.refereeName || "",
            refereeAddressLine1: item.refereeAddressLine1 || "",
            refereeAddressLine2: item.refereeAddressLine2 || "",
            refereeEmail: item.refereeEmail || "",
            refereePhone1: item.refereePhone1 || "",
            refereePhone2: item.refereePhone2 || "",
            refereePhone3: item.refereePhone3 || "",
            relationshipWithEmployee: item.relationshipWithEmployee || "",
            yearsKnown: item.yearsKnown || "",
            characterComment: item.characterComment || "",
            recommendEmployee: item.recommendEmployee || "",
            reasonIfNo: item.reasonIfNo || "",
            generalComments: item.generalComments || "",
            signatureDate: item.signatureDate || "",
            refereePassportUrl: item.refereePassportUrl || "",
            refereeSignatureUrl: item.refereeSignatureUrl || "",
            recommendationLetters: item.recommendationLetters || [],
        });

        setPassportPreview(item.refereePassportUrl || "");
        setSignaturePreview(item.refereeSignatureUrl || "");
        setImagePreviewPic(item.recommendationLetters || []);
        setEdit(true)
    };

    const handleUpdate = async () => {
        try {
            const payload = {
                id: form.id || 0,
                refereePassport: selectedFile || form.refereePassport,
                employeeName: form.employeeName,
                refereeName: form.refereeName,
                refereeAddressLine1: form.refereeAddressLine1,
                refereeAddressLine2: form.refereeAddressLine2,
                refereeEmail: form.refereeEmail,
                refereePhone1: form.refereePhone1,
                refereePhone2: form.refereePhone2,
                refereePhone3: form.refereePhone3,
                relationshipWithEmployee: form.relationshipWithEmployee,
                yearsKnown: Number(form.yearsKnown) || 0,
                characterComment: form.characterComment,
                recommendEmployee: form.recommendEmployee,
                reasonIfNo: form.reasonIfNo,
                generalComments: form.generalComments,
                recommendationLetters: base64Files,
                refereeSignature: selectedSignature,
                signatureDate: form.signatureDate
            }
            setLoadingUploading(true);
            const res = await createReference(admToken, payload, user?.staffId);
            if (res.status && res.statusCode === 2) {
                toast.success(res.message);
                getRef();
                setForm({
                    id: 0,
                    employeeName: "",
                    refereeName: "",
                    refereeAddressLine1: "",
                    refereeAddressLine2: "",
                    refereeEmail: "",
                    refereePhone1: "",
                    refereePhone2: "",
                    refereePhone3: "",
                    relationshipWithEmployee: "",
                    yearsKnown: 0,
                    characterComment: "",
                    recommendEmployee: "",
                    reasonIfNo: "",
                    generalComments: "",
                    refereePassport: "",
                    refereeSignature: "",
                    signatureDate: "",
                    recommendationLetters: []
                })
            } else {
                toast.error(res.message || "Please fill the form correctly and retry");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingUploading(false)
        }
    };

    return (
        <div className="w-full min-h-screen bg-white flex items-center justify-center flex-col py-10 px-4"
            styles={{ fontStyle: "Gilroy-Bold" }}
        >
            <div className="w-full max-w-4xl border border-primary p-8 rounded-lg">
                <h2 className="text-center text-xl font-bold mb-6">
                    LAGOS ANGLICAN SCHOOLS MANAGEMENT BOARD
                </h2>

                <h3 className="text-center font-semibold underline text-lg mb-6">
                    EMPLOYEE REFERENCE FORM
                </h3>

                <div className="flex justify-end mb-4">
                    <div
                        className="relative w-28 h-28 md:w-32 md:h-32 border border-primary flex items-center justify-center text-center text-xs text-gray-500"
                        onClick={handlePassportClick}
                        disabled={!(status === 0 || status === 4) || loading}
                    >
                        <div className="w-28 h-28 md:w-32 md:h-32 bg-gray-100 flex items-center justify-center border text-center text-xs text-gray-500 border-primary overflow-hidden">
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleSelectPassport}
                                accept="image/jpeg"
                                hidden
                                disabled={!(status === 0 || status === 4) || loading}
                            />
                            {imagePassportPreview ? (
                                <img
                                    src={
                                        imagePassportPreview ||
                                        'https://placehold.co/200x200?text=No+Images'
                                    }
                                    alt="profile picture"
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="border-gray-300 flex items-center justify-center text-center text-xs text-gray-500 p-5 mb-2">
                                    <label>FIX PASSPORT PHOTOGRAPH (JPEG)</label>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <div className="w-32 h-32 border border-gray-300 flex items-center justify-center text-center text-xs text-gray-500">
                        FIX PASSPORT PHOTOGRAPH (JPEG)
                    </div> */}
                </div>

                <form className="space-y-6">
                    <InputWrapper>
                        <label htmlFor="employeeName" className="block mb-1">RE: (NAME OF EMPLOYEE)</label>
                        <input
                            type="text"
                            placeholder="Name Employee"
                            disabled={!(status === 0 || status === 4) || loading}
                            value={form.employeeName}
                            onChange={(e) => setForm({ ...form, employeeName: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                        />
                    </InputWrapper>

                    <InputWrapper>
                        <label htmlFor="refereeName" className="block mb-1"> Name of Referee</label>
                        <input
                            type="text"
                            placeholder="Referee Name"
                            disabled={!(status === 0 || status === 4) || loading}
                            value={form.refereeName}
                            onChange={(e) => setForm({ ...form, refereeName: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <label htmlFor="refereeAddressLine1" className="block mb-1">Address of Referee</label>
                        <textarea
                            placeholder="Address of Referee"
                            disabled={!(status === 0 || status === 4) || loading}
                            value={form.refereeAddressLine1}
                            onChange={(e) => setForm({ ...form, refereeAddressLine1: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                            rows={2}
                        ></textarea>
                    </InputWrapper>
                    <InputWrapper>
                        <label htmlFor="refereeEmail" className="block mb-1">E-mail Address of Referee</label>
                        <input
                            type="text"
                            placeholder="Referee Email"
                            disabled={!(status === 0 || status === 4) || loading}
                            value={form.refereeEmail}
                            onChange={(e) => setForm({ ...form, refereeEmail: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                        />
                    </InputWrapper>

                    <InputWrapper>
                        <label className="block mb-1"> Numbers of Referee</label>
                        <div className="grid grid-cols-3 gap-4">
                            <div className="flex items-end gap-1">
                                <label htmlFor="refereePhone1" className="block mb-1">(1)</label>
                                <input
                                    type="text"
                                    placeholder="Referee Phone1"
                                    disabled={!(status === 0 || status === 4) || loading}
                                    value={form.refereePhone1}
                                    onChange={(e) => setForm({ ...form, refereePhone1: (e.target.value) })}
                                    className="p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                                />
                            </div>
                            <div className="flex items-end gap-1">
                                <label htmlFor="refereePhone2" className="block mb-1">(2)</label>
                                <input
                                    type="text"
                                    placeholder="Referee Phone2"
                                    disabled={!(status === 0 || status === 4) || loading}
                                    value={form.refereePhone2}
                                    onChange={(e) => setForm({ ...form, refereePhone2: (e.target.value) })}
                                    className="p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                                />
                            </div>
                            <div className="flex items-end gap-1">
                                <label htmlFor="refereePhone3" className="block mb-1">(3)</label>
                                <input
                                    type="text"
                                    placeholder="Referee Phone3"
                                    disabled={!(status === 0 || status === 4) || loading}
                                    value={form.refereePhone3}
                                    onChange={(e) => setForm({ ...form, refereePhone3: (e.target.value) })}
                                    className="p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                                />
                            </div>
                        </div>
                    </InputWrapper>

                    <InputWrapper>
                        <label htmlFor="relationshipWithEmployee" className="block mb-1">What is your relationship with the employee?</label>
                        <input
                            type="text"
                            placeholder="Relationship With Employee"
                            disabled={!(status === 0 || status === 4) || loading}
                            value={form.relationshipWithEmployee}
                            onChange={(e) => setForm({ ...form, relationshipWithEmployee: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                        />
                    </InputWrapper>

                    <InputWrapper>
                        <label htmlFor="yearsKnown" className="block mb-1">How long have you known him/her?</label>
                        <input
                            type="text"
                            placeholder="Years Known"
                            disabled={!(status === 0 || status === 4) || loading}
                            value={form.yearsKnown}
                            onChange={(e) => setForm({ ...form, yearsKnown: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                        />
                    </InputWrapper>

                    <InputWrapper>
                        <label htmlFor="characterComment" className="block mb-1">Please comment briefly on his/her character, integrity, attitude etc.</label>
                        <textarea
                            placeholder="Character Comment"
                            disabled={!(status === 0 || status === 4) || loading}
                            value={form.characterComment}
                            onChange={(e) => setForm({ ...form, characterComment: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                            rows={3}
                        ></textarea>
                    </InputWrapper>

                    <InputWrapper>
                        <label htmlFor="recommendEmployee" className="block mb-1">
                            Do you recommend him/her as an employee in our organization? (Yes/No)
                        </label>
                        <input
                            type="text"
                            placeholder="Recommend Employee"
                            value={form.recommendEmployee}
                            disabled={!(status === 0 || status === 4) || loading}
                            onChange={(e) => setForm({ ...form, recommendEmployee: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                        />
                    </InputWrapper>

                    <InputWrapper>
                        <label htmlFor="reasonIfNo" className="block mb-1">If 'No' please state reasons</label>
                        <textarea
                            placeholder="Reason If No"
                            disabled={!(status === 0 || status === 4) || loading}
                            value={form.reasonIfNo}
                            onChange={(e) => setForm({ ...form, reasonIfNo: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                            rows={2}
                        ></textarea>
                    </InputWrapper>

                    <InputWrapper>
                        <label htmlFor="generalComments" className="block mb-1">General Comments</label>
                        <textarea
                            placeholder="General Comments"
                            disabled={!(status === 0 || status === 4) || loading}
                            value={form.generalComments}
                            onChange={(e) => setForm({ ...form, generalComments: (e.target.value) })}
                            className="w-full p-2 border border-gray-600 rounded outline-none focus:outline:none focus:ring-0"
                            rows={3}
                        ></textarea>
                    </InputWrapper>

                    <div className="flex justify-between my-5 gap-10">
                        <InputWrapper>
                            <label htmlFor="">Signature of Refree (Jpeg)</label>
                            <div
                                className="relative w-28 h-28 md:w-80 md:h-36 bg-gray-100 mt-2 mb-4"
                                onClick={handleSignatureUplaod}
                                disabled={!(status === 0 || status === 4) || loading}
                            >
                                <div className="h-full md:w-80 md:h-36 bg-gray-100 flex items-center justify-center border border-dashed border-primary overflow-hidden rounded-lg">
                                    <input
                                        type="file"
                                        ref={signatureInputRef}
                                        onChange={handleSignChange}
                                        accept="image/jpeg"
                                        hidden
                                        disabled={!(status === 0 || status === 4) || loading}
                                    />
                                    {signaturePreview ? (
                                        <img
                                            src={
                                                signaturePreview ||
                                                'https://placehold.co/200x200?text=No+Images'
                                            }
                                            alt="profile picture"
                                            className="w-full h-full object-contain"
                                        />
                                    ) : (
                                        <div className="flex flex-col space-y-6 justify-center py-10 items-center p-5 mb-2">
                                            <Upload /> {" "}
                                            <label>Click to upload your Signature</label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </InputWrapper>

                        <InputWrapper>
                            <label htmlFor="">Date</label>
                            <DatePickerComponent
                                selected={form.signatureDate ? new Date(form.signatureDate) : null}
                                setSelected={(val) => {
                                    setForm({ ...form, signatureDate: val.toISOString() });
                                }}
                                disabled={!(status === 0 || status === 4) || loading}
                            />
                        </InputWrapper>
                    </div>
                    <InputWrapper>
                        <label htmlFor="">Attach Recommendation Letters (max 2- Pdf/jpeg)</label>
                        <div
                            className="relative w-28 h-28 md:w-full md:h-36 bg-gray-100 mt-2 mb-4"
                            onClick={handleRecommendationClick}
                            disabled={!(status === 0 || status === 4) || loading}
                        >
                            <div className="h-full md:w-full md:h-36 bg-gray-100 flex items-center justify-center border border-dashed border-primary overflow-hidden rounded-lg">
                                <input
                                    type="file"
                                    ref={imageInputRef}
                                    onChange={handleRecommendationLetter}
                                    accept="Pdf/jpeg"
                                    multiple
                                    hidden
                                    disabled={!(status === 0 || status === 4) || loading}
                                />
                                {imagePreviewPic.length > 0 ? (
                                    <div className="flex gap-2 overflow-x-auto p-2">
                                        {imagePreviewPic.map((url, idx) => {
                                            const isPDF = selectedPic[idx]?.type === "application/pdf";

                                            return (
                                                <div
                                                    key={idx}
                                                    className="w-20 h-20 bg-white border rounded flex items-center justify-center text-xs font-semibold"
                                                >
                                                    {isPDF ? (
                                                        <span className="text-red-600">📄 PDF</span>
                                                    ) : (
                                                        <img
                                                            src={url}
                                                            alt={`preview-${idx}`}
                                                            className="h-full w-full object-cover rounded"
                                                        />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="flex flex-col space-y-6 justify-center py-10 items-center p-5 mb-2">
                                        <Upload />
                                        <label>Click to upload your Signature / PDFs</label>
                                    </div>
                                )}
                            </div>
                        </div>

                    </InputWrapper>
                    <div className="p-4 border border-primary rounded my-7 font-medium">
                        <p className="font-bold text-lg uppercase text-center">RECOMMENDATION LETTER</p>
                        <div className="mt-2 mb-5">
                            Attach recommendation letter from two guarantors each in the attachment section. The letters should be written to the address below:
                        </div>
                        <div className="space-y-2">
                            <p>The Executive Secretary,</p>
                            <p>Lagos Anglican Schools Management Board,</p>
                            <p>17, Broad Street,</p>
                            <p>Lagos.</p>
                        </div>
                        <div className="space-y-2 mt-5">
                            <p>Or</p>
                            <p>thelasmab@yahoo.com</p>
                        </div>
                    </div>
                    <p className="text-sm font-semibold my-4">
                        (N.B: Referee must know the applicant for a period not less than three years.)
                    </p>
                </form>
            </div>
            {status === 4 || status === 0 && (
                <div className="flex items-center justify-end my-7">
                    <button
                        disabled={loadingUploading}
                        onClick={handleUpdate}
                        className="px-8 py-2.5 rounded-lg text-white bg-primary disabled:cursor-not-allowed disabled:bg-gray-300"
                    >
                        {loadingUploading ? edit ? "Updating" : "Saving" : edit ? "update" : "Save"}
                    </button>
                </div>
            )}
            <AccountSummaryWrapper
                style={{
                    border: `1px solid ${colors.primary}`,
                    paddingTop: "0px",
                    borderRadius: "10px",
                    marginTop: "10px",
                }}
            >
                <table>
                    <tr className="table-head" style={{ color: "black" }}>
                        <th>S/N</th>
                        <th>Employee Name</th>
                        <th>Refree Name</th>
                        <th>Relationship</th>
                        <th>Relationship year(s)</th>
                        <th></th>
                    </tr>
                    {loading ?
                        <tr colSpan={5}><FormLoader /></tr>
                        : data?.length > 0 ? (
                            data?.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.employeeName}</td>
                                    <td>{item.refereeName}</td>
                                    <td>{item.relationshipWithEmployee}</td>
                                    <td>{item.yearsKnown} year(s)</td>
                                    <td>
                                        <div
                                            style={{
                                                width: "100%",
                                                display: "inline-flex",
                                                justifyContent: "space-evenly",
                                            }}
                                        >
                                            <button
                                                style={{
                                                    color: "black",
                                                    fontWeight: "bold",
                                                    padding: "0.3rem 0.6rem",
                                                    backgroundColor: "transparent",
                                                    borderColor: colors.primary,
                                                    borderWidth: "1px",
                                                    borderRadius: "5px",
                                                }}
                                                onClick={() => handleEdit(item)}
                                                disabled={!(status === 0 || status === 4) || loading || loadingUploading}
                                            >
                                                Edit
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={5} style={{ textAlign: "center" }}>
                                    <p className="text-center p-4">
                                        No Recommendation Letter
                                    </p>
                                </td>
                            </tr>
                        )}
                </table>
            </AccountSummaryWrapper>
        </div>
    );
}
